export const PIN_FIELD_NAME = 'data.attributes.pin';
export const PIN_CONFIRM_FIELD_NAME = 'pin-confirm';
